import { useTranslation } from 'react-i18next';
import { date, object, string, number, array } from 'yup';

import { PolicyTypes } from '@models/policyType';
import { yupPercentage } from '@utils/yup';

import { FormValues } from './type';

export const useFormValues = () => {
  const values: FormValues = {
    insurerId: '',
    insurerTeamId: '',
    insuranceTemplateId: '',
    benefitTemplateIds: [],
    companyId: '',
    insuranceType: '',
    policyType: '',
    effectiveDate: '',
    expirationDate: '',
    adminFeeAmount: '',
    brokeragePercentage: 0.0,
    descriptionHtml: '',
  };
  return values;
};

export const useFormSchema = () => {
  const { t } = useTranslation();
  return object({
    insurerId: number().required(t('validation:required')),
    insurerTeamId: number().required(t('validation:required')),
    insuranceTemplateId: number().optional(),
    benefitTemplateIds: array().of(number()).required(t('validation:required')),
    companyId: number()
      .when('policyType', {
        is: (policyType: PolicyTypes) => policyType === PolicyTypes.Commercial,
        then: (schema) => schema.required(t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
    insuranceType: string().required(t('validation:required')),
    policyType: string().required(t('validation:required')),
    effectiveDate: date().required(t('validation:required')),
    expirationDate: date().required(t('validation:required')),
    adminFeeAmount: number().required(t('validation:required')),
    brokeragePercentage: yupPercentage(),
    descriptionHtml: string().optional(),
  });
};
